import {httpClient} from '@api/baseApi';

export async function login(formData: FormData) {
  try {
    const {data} = await httpClient.post(`login`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } catch (err) {
    return err;
  }
}
